import { FieldValues } from "react-hook-form";
import { ChronicleFilenamesEnum, PlanningModeEnum } from "shared/enums/globalEnums";

export enum FcrPlanningEnum {
  planning_soc_1 = "planning_soc_1",
  planning_trial_1b = "planning_trial_1b",
  planning_soc_1_2 = "planning_soc_1_2",
  planning_trial_2 = "planning_trial_2",
  planning_soc_2_3 = "planning_soc_2_3",
  planning_trial_3 = "planning_trial_3",
  planning_soc_3_4 = "planning_soc_3_4",
  planning_trial_4 = "planning_trial_4",
  planning_soc_4_5 = "planning_soc_4_5",
  planning_trial_5 = "planning_trial_5",
  planning_soc_8h = "planning_soc_8h",
  planning_trial_8h = "planning_trial_8h",
}

export enum TargetSocTypeEnum {
  soc_trial_1 = "soc_trial_1",
  soc_trial_3 = "soc_trial_3",
  soc_trial_2_4 = "soc_trial_2_4",
  notApplicable = "notApplicable",
}

export enum SocRestorationPowerKeyEnum {
  soc_restoration_1_3 = "soc_restoration_1_3",
  soc_restoration_2_4 = "soc_restoration_2_4",
}

export interface PlanningConfig {
  name: FcrPlanningEnum;
  mode: PlanningModeEnum;
  durationInMinutes: number;
  target_soc_type: TargetSocTypeEnum | null;
  soc_restoration_power_key: SocRestorationPowerKeyEnum | null;
  chronicleFilename: ChronicleFilenamesEnum | null;
  reactivity_delay: number;
}

export interface InitialData extends FieldValues {
  startingDate: string;
  soc_trial_1: number;
  soc_trial_3: number;
  soc_trial_2_4: number;
  fcr_engagement_default: number;
  initial_soc_restoration_1_3: number;
  initial_soc_restoration_2_4: number;
  site_ids: number[];
}
